export const PROJECT_STORE_KEY = 'mendian_current_store';
export const PROJECT_USER_KEY = 'mendian_user_info';
export const MICRO_BASE_DATA = 'micro_base_data';
export const FE_ENV_BRANCH = 'fe_env_branch'; // 前端分支测试环境
export const BACK_TIP_KEY = 'needBackTipStatus'; // 是否需要基座阻断返回
export const PROJECT_HOME_PATH = 'project_home_path';
export const BASE_TABS_STATE = 'BASE_TABS_STATE'